const socialList =
  [
    {
    "key" : 1,
    "icon" : "twitter-x-seeklogocom-4",
    "url" : "https://twitter.com/fundaciogoel",
    "title": "Twitter",
    "iconClassName": "fill"
   },
  {
    "key" : 2,
    "icon" : "icons-32-x-32-export-facebook",
    "url" : "https://facebook.com/goel.fundacio",
    "title": "Facebook",
    "iconClassName": "no-fill"
  },
  {
    "key" : 3,
    "icon" : "icons-32-x-32-export-instagram",
    "url" : "https://instagram.com/fundaciogoel",
    "title": "Instagram",
    "iconClassName": "no-fill"
  }
]

export default socialList
